export default __webpack_public_path__ + "static/me-de4374a9b9510fd57c7a2cc5953e3f34.jpg";